import api from "../store/services/api";

export const getSmartRoutingConfig = async () =>
  await api.get("/smart-routing/config/");

export const updateSmartRoutingConfig = async (config) =>
  await api.put("/smart-routing/config/", config, {
    headers: { "Content-Type": "application/json" },
  });

export const getSmartRoutingPresets = async () =>
  await api.get("/smart-routing/presets/");

export const getSmartRoutingSuggestions = async () =>
  await api.get("/smart-routing/suggestions/");

export const previewSmartRouting = async (config) =>
  await api.post(
    "/smart-routing/preview/",
    { config },
    { headers: { "Content-Type": "application/json" } }
  );

export const dispatchSmartRoute = async ({
  calculation_id,
  cluster_id,
  driver_id,
  order_ids,
}) =>
  await api.post(
    "/smart-routing/dispatch/",
    { calculation_id, cluster_id, driver_id, order_ids },
    { headers: { "Content-Type": "application/json" } }
  );

export const triggerSmartRouting = async () =>
  await api.post("/smart-routing/trigger/");

const SmartRoutingService = {
  getSmartRoutingConfig,
  updateSmartRoutingConfig,
  getSmartRoutingPresets,
  getSmartRoutingSuggestions,
  previewSmartRouting,
  dispatchSmartRoute,
  triggerSmartRouting,
};

export default SmartRoutingService;
